export const CLOSE_SUCCESS_ALERT = 'CLOSE_SUCCESS_ALERT';
export const CREATE_INSTITUTION_ACCOUNT = 'CREATE_INSTITUTION_ACCOUNT';
export const DISABLE_SUBMIT_DETAIL_TRANSACTION = 'DISABLE_SUBMIT_DETAIL_TRANSACTION';
export const DISABLE_SUBMIT_SEARCH = 'DISABLE_SUBMIT_SEARCH';
export const ENABLE_SUBMIT_DETAIL_TRANSACTION = 'ENABLE_SUBMIT_DETAIL_TRANSACTION';
export const ENABLE_SUBMIT_SEARCH = 'ENABLE_SUBMIT_SEARCH';
export const GET_NOTES_LIST_FAILURE = 'GET_NOTES_LIST_FAILURE';
export const GET_NOTES_LIST_REQUEST = 'GET_NOTES_LIST_REQUEST';
export const GET_NOTES_LIST_SUCCESS = 'GET_NOTES_LIST_SUCCESS';
export const GET_TRANSACTION_FAILURE = 'GET_TRANSACTION_FAILURE';
export const GET_TRANSACTION_LIST_FAILURE = 'GET_TRANSACTION_LIST_FAILURE';
export const GET_TRANSACTION_LIST_REQUEST = 'GET_TRANSACTION_LIST_REQUEST';
export const GET_TRANSACTION_LIST_SUCCESS = 'GET_TRANSACTION_LIST_SUCCESS';
export const GET_TRANSACTION_REQUEST = 'GET_TRANSACTION_REQUEST';
export const GET_TRANSACTION_SUCCESS = 'GET_TRANSACTION_SUCCESS';
export const GET_UPCOMING_TRANSACTIONS_REQUEST = 'GET_UPCOMING_TRANSACTIONS_REQUEST';
export const GET_UPCOMING_TRANSACTIONS_RESPONDED = 'GET_UPCOMING_TRANSACTIONS_RESPONDED';
export const HIDE_ACCOUNT_CREATION_MODAL = 'HIDE_ACCOUNT_CREATION_MODAL';
export const HIDE_CANCEL_BUTTON = 'HIDE_CANCEL_BUTTON';
export const HIDE_CHECK_WIRE_MODAL = 'HIDE_CHECK_WIRE_MODAL';
export const HIDE_ERRORS_MODAL = 'HIDE_ERRORS_MODAL';
export const HIDE_INFORMATION_MODAL = 'HIDE_INFORMATION_MODAL';
export const HIDE_QUESTION_MODAL = 'HIDE_QUESTION_MODAL';
export const HIDE_SUCCESS_MODAL = 'HIDE_SUCCESS_MODAL';
export const HIDE_TRANSACTION_MODAL = 'HIDE_TRANSACTION_MODAL';
export const IMPACT_PREFERENCES_UPDATED = 'IMPACT_PREFERENCES_UPDATED';
export const PURCHASE_NOTE_FAILURE = 'PURCHASE_NOTE_FAILURE';
export const PURCHASE_NOTE_REQUEST = 'PURCHASE_NOTE_REQUEST';
export const PURCHASE_NOTE_SUCCESS = 'PURCHASE_NOTE_SUCCESS';
export const SET_ACCOUNT_STATUS = 'SET_ACCOUNT_STATUS';
export const SET_ACTIVE_ACCOUNT_ID = 'SET_ACTIVE_ACCOUNT_ID';
export const SET_CHANGE_ADDRESS = 'SET_CHANGE_ADDRESS';
export const SET_CREATION_SUCCEEDED = 'SET_CREATION_SUCCEEDED';
export const SET_DEFAULT_FUNDING_SOURCE = 'SET_DEFAULT_FUNDING_SOURCE';
export const SET_DOCUMENTATION_REASON = 'SET_DOCUMENTATION_REASON';
export const SET_ERRORS_MODAL_INFO = 'SET_ERRORS_MODAL_INFO';
export const SET_IDLE_OFF = 'SET_IDLE_OFF';
export const SET_IDLE_ON = 'SET_IDLE_ON';
export const SET_IR_ADMIN_ROLE = 'SET_IR_ADMIN_ROLE';
export const SET_NEEDS_DOCUMENTATION = 'SET_NEEDS_DOCUMENTATION';
export const SET_NEW_USER_EMAIL = 'SET_NEW_USER_EMAIL';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const SET_STATES = 'SET_STATES';
export const SET_CANADA_STATES = 'SET_CANADA_STATES';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_STATIC_INFORMATION = 'SET_STATIC_INFORMATION';
export const SET_MAINTENANCE = 'SET_MAINTENANCE';
export const SET_SUGGESTED_ADDRESS = 'SET_SUGGESTED_ADDRESS';
export const SET_SUGGESTED_ADDRESS_MODAL_VISIBLE = 'SET_SUGGESTED_ADDRESS_MODAL_VISIBLE';
export const SET_SUGGESTED_ADDRESS_TYPE = 'SET_SUGGESTED_ADDRESS_TYPE';
export const SET_SUGGESTED_ADDRESS_YES_METHOD = 'SET_SUGGESTED_ADDRESS_YES_METHOD';
export const SET_SUGGESTED_ADDRESS_YES_CALL = 'SET_SUGGESTED_ADDRESS_YES_CALL';
export const SET_TRANSACTION = 'SET_TRANSACTION';
export const SET_USER = 'SET_USER';
export const SET_USER_BY_ADMIN = 'SET_USER_BY_ADMIN';
export const SET_USER_STATUS = 'SET_USER_STATUS';
export const SHOW_ACCOUNT_CREATION_MODAL = 'SHOW_ACCOUNT_CREATION_MODAL';
export const SHOW_CHECK_WIRE_MODAL = 'SHOW_CHECK_WIRE_MODAL';
export const SHOW_ERRORS_MODAL = 'SHOW_ERRORS_MODAL';
export const SHOW_INFORMATION_MODAL = 'SHOW_INFORMATION_MODAL';
export const SHOW_QUESTION_MODAL = 'SHOW_QUESTION_MODAL';
export const SHOW_SUCCESS_ALERT = 'SHOW_SUCCESS_ALERT';
export const SHOW_SUCCESS_MODAL = 'SHOW_SUCCESS_MODAL';
export const SHOW_TRANSACTION_MODAL = 'SHOW_TRANSACTION_MODAL';
export const START_DOCUMENT_UPLOAD = 'START_DOCUMENT_UPLOAD';
export const START_LOGIN_REQUEST = 'START_LOGIN_REQUEST';
export const START_REGISTRATION_REQUEST = 'START_REGISTRATION_REQUEST';
export const STOP_DOCUMENT_UPLOAD = 'STOP_DOCUMENT_UPLOAD';
export const STOP_LOGIN_REQUEST = 'STOP_LOGIN_REQUEST';
export const STOP_REGISTRATION_REQUEST = 'STOP_REGISTRATION_REQUEST';
export const STOP_SET_DEFAULT_FUNDING_SOURCE = 'STOP_SET_DEFAULT_FUNDING_SOURCE';
export const UPDATE_UPCOMING_TRANSACTION_REQUEST = 'UPDATE_UPCOMING_TRANSACTION_REQUEST';
export const UPDATE_UPCOMING_TRANSACTION_RESPONDED = 'UPDATE_UPCOMING_TRANSACTION_RESPONDED';
export const SET_SEARCH_STRING = 'SET_SEARCH_STRING';
export const SET_CURRENTLY_SEARCHING_BY = 'SET_CURRENTLY_SEARCHING_BY';
export const SET_NOTIFICATION_STATUS = 'SET_NOTIFICATION_STATUS';
export const SET_COMMUNICATION_PREFERENCES_NOTIFICATION = 'SET_COMMUNICATION_PREFERENCES_NOTIFICATION';
export const SET_LOADING_REDIRECTION = 'SET_LOADING_REDIRECTION';
export const SET_CURRENT_DWOLLA_CUSTOMER_ID = 'SET_CURRENT_DWOLLA_CUSTOMER_ID';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js